import { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Dialog as MaterialDialog } from "@mui/material";

import { MultiplyIcon } from "../../icons";
import { handleEvent } from "@gx1/gx-npm-lib";
import { IconButton } from "../iconButton";
import classNames from "classnames";
import { TypographyComponent } from "../typography/typography.component";
import styles from "./dialog.styles.module.scss";

const variantType = {
  dialog: "dialog",
  overlay: "overlay"
};

const propTypes = {
  body: PropTypes.any, // ReactNode | string
  bodyScrollable: PropTypes.bool,
  closeIcon: PropTypes.bool,
  footer: PropTypes.any, // ReactNode | string
  handleClose: PropTypes.func,
  height: PropTypes.string,
  maxDialogWidth: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  rootClassName: PropTypes.string,
  title: PropTypes.any, // ReactNode | string
  variant: PropTypes.string,
  hasFooterScrollShadow: PropTypes.bool,
  closeIconClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  paperClassName: PropTypes.string,
  bodyWrapperClassName: PropTypes.string,
  disableRestoreFocus: PropTypes.bool,
  ariaLabel: PropTypes.string
};

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const Dialog = ({
  body,
  bodyScrollable = false,
  closeIcon = false,
  footer,
  handleClose = (_event) => { },
  height,
  maxDialogWidth = "600px",
  open = false,
  onClose = (_event) => { },
  rootClassName = "",
  title,
  variant = "",
  hasFooterScrollShadow = false,
  closeIconClassName = "",
  wrapperClassName = "",
  titleClassName = "",
  paperClassName = "",
  bodyWrapperClassName = "",
  disableRestoreFocus = false,
  ariaLabel = ""
}) => {
  const bodyHeight = footer ? 216 : 145;
  const { t } = useTranslation();
  const [isScrolling, setIsScrolling] = useState(false);

  const handleCloseDialog = (isClosing, e) => {
    if (isClosing) {
      handleEvent(handleClose, e);
      handleEvent(onClose, e);
    }
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    setIsScrolling(scrollTop !== 0 && scrollTop !== scrollHeight - clientHeight);
  };
  return (
    <MaterialDialog
      open={open}
      onClose={(e) => handleCloseDialog(!closeIcon, e)}
      PaperProps={{
        style: {
          borderRadius: 8,
          overflowY: "hidden",
          maxWidth: maxDialogWidth
        }
      }}
      slotProps={{
        backdrop: {
          style: { backgroundColor: "rgba(from var(--gravx-color-neutral-on-light-grey-7) r g b / 0.5)" }
        }
      }}
      aria-label={ariaLabel || t("Dialog")}
      classes={{ root: styles.root, paper: paperClassName }}
      className={classNames(variantType.dialog === variantType[variant] && "gx-dialog", rootClassName)}
      disableRestoreFocus={disableRestoreFocus}
    >
      <div
        className={classNames(styles.container, bodyScrollable && "gx-scrollable", wrapperClassName)}
        style={{ height }}
      >
        <div className={classNames(styles.title, "gx-dialog-title", titleClassName)}>
          <TypographyComponent styling={"h4"} color={"carbon"} boldness={"medium"}>
            {title}
          </TypographyComponent>
          {closeIcon && (
            <IconButton
              ariaLabel={t("close icon")}
              rootClassName={classNames(styles.closeButton, closeIconClassName)}
              onClick={(e) => handleCloseDialog(true, e)}
              focusBackgroundColor={"var(--gravx-color-neutral-on-light-white)"}
              hoverBackgroundColor={"var(--gravx-color-neutral-on-light-white)"}
            >
              <MultiplyIcon />
            </IconButton>
          )}
        </div>
        <div
          onScroll={(e) => {
            if (hasFooterScrollShadow) {
              handleScroll(e);
            }
          }}
          className={classNames(styles.body, "gx-dialog-body", bodyWrapperClassName)}
          style={bodyScrollable ? { height: `calc(100% - ${bodyHeight}px)` } : {}}
        >
          {body}
        </div>
        <div className={classNames(styles.footer, "gx-dialog-footer", isScrolling && "scrolling")}>{footer}</div>
      </div>
    </MaterialDialog>
  );
};
Dialog.propTypes = propTypes;
export { Dialog, variantType };
